<button class="btn btn-primary d-md-none mb-2" type="button" (click)="toggleSidebar()">
    <span class="navbar-toggler-icon"></span> Menú
</button>
<nav id="sidebarMenu" class="bg-white sidebar shadow-sm  d-print-none" [ngbCollapse]="sidebarCollapsed">
    <div class="sidebar-sticky pt-3">
        <ng-container *ngFor="let section of menuSections">
            <h6 class="sidebar-heading px-3 mb-2 text-muted font-weight-bold" *ngIf="section.title">
                <span>{{ section.title }}</span>
            </h6>
            <ul class="nav flex-column mb-3" *ngIf="section.items && section.items.length">
                <li class="nav-item" *ngFor="let item of section.items">
                    <a class="nav-link d-flex align-items-center" [routerLink]="[item.route]">
                        <span class="mr-2" style="font-size: 1.2rem;" *ngIf="item.icon">{{ item.icon }}</span>
                        <span>{{ item.label }}</span>
                    </a>
                </li>
            </ul>
        </ng-container>
    </div>
</nav>